import comp from "./CollaboratorV2SearchDropdownList";
export default comp;
